export default function validationChargeTravail(response, messages) {
  if (!response.data.error || !response.data.error.validationErrors) {
    return;
  }
  response.data.error.validationErrors.forEach((error) => {
    const message = error.message;
    if (message.indexOf('COMPANY_SHOULD_CONTAINS_DISPLAY_SCRAPING_PRODUCT') === 0) {
      messages.push({ message: 'chargeTravailAff.messages.errors.displayScraping' });
    }
    if (message.indexOf('STRING_LENGTH_1_100') === 0 && error.members[0] === 'ville') {
      messages.push({ message: 'chargeTravailAff.messages.errors.villeRequired' });
    }
    if (message.indexOf('STATE_SHOULD_NOT_BE_CLOSED') === 0
      || message.indexOf('STATE_SHOULD_BE_SAVE') === 0) {
      messages.push({ message: 'chargeTravailAff.popUpAffecter.messages.errors.otSave' });
    }
    if (message.indexOf('DISPLAY_WORK_ORDER_SHOULD_BE_CLOSED_TO_REACTIVATE') === 0) {
      messages.push({ message: 'detailOrdreTravailAffichage.popUpReactive.error' });
    }
    if (message.indexOf('DISPLAY_WORK_ORDER_SHOULD_BE_SAVED_TO_CLOSE') === 0) {
      messages.push({ message: 'detailOrdreTravailAffichage.popUpClocture.error' });
    }
  });
}
